"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ProgressBar',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '处理中...'
    },
    percentage: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val >= 0 && val <= 100;
      }
    },
    statusText: {
      type: String,
      default: '正在处理...'
    },
    isError: {
      type: Boolean,
      default: false
    },
    isSuccess: {
      type: Boolean,
      default: false
    },
    canCancel: {
      type: Boolean,
      default: true
    },
    canRetry: {
      type: Boolean,
      default: true
    },
    showCloseButton: {
      type: Boolean,
      default: false
    },
    showDetails: {
      type: Boolean,
      default: true
    },
    showActions: {
      type: Boolean,
      default: true
    },
    speed: {
      type: String,
      default: ''
    },
    timeRemaining: {
      type: String,
      default: ''
    },
    fileSize: {
      type: String,
      default: ''
    },
    allowClickOutside: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formattedPercentage: function formattedPercentage() {
      var num = Number(this.percentage);
      // 如果是整数，显示不带小数点的格式，否则保留两位小数
      return num % 1 === 0 ? num.toString() : num.toFixed(2);
    }
  },
  methods: {
    handleClose: function handleClose() {
      this.$emit('close');
    },
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    },
    handleRetry: function handleRetry() {
      this.$emit('retry');
    },
    handleComplete: function handleComplete() {
      this.$emit('complete');
    },
    handleOverlayClick: function handleOverlayClick() {
      if (this.allowClickOutside) {
        this.handleClose();
      }
    }
  }
};